import * as http from "../../index";
import Configuration from "../../../config/index";
export const requestCancelSignCase = (caseId) => {
    const host = Configuration.current().getApiAddress();
    const url = `${host}/credit-assessment/sign/${caseId}`;
    const forgeryToken = http.context().requestForgeryToken;
    const request = http
        .builder()
        .method("delete")
        .requestForgeryToken(forgeryToken)
        .build();
    return http.raw(url, request);
};
